import SettingsLogsTable from "@/features/settings-logs/SettingsLogsTable";
import { API_LOGS } from "@/api/queries";
import { usePaginatedTableRequest } from '@/components/tables/hooks/usePaginatedTableRequest';

const SettingsLogs = () => {
  const {
    data,
    pagination,
    setPagination,
    loading
  } = usePaginatedTableRequest(API_LOGS);

  return (
    <SettingsLogsTable 
      apiLogs={data?.crmApiLogs?.items} 
      pagination={pagination}
      setPagination={setPagination}
      totalCount={data?.crmApiLogs?.totalCount}
      loading={loading}
    />
  );
};

export default SettingsLogs;
